import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FinishingVendorService } from '../../../vendor/data/finish-vendor.service';
import { ProjectService } from '../../data/project/project.service';
import { Project } from '../../data/project/project';
import { FinishingVendor } from '../../../vendor/data/finish-vendor';
import { WsUpdateResponce } from '../../../data/ws-update-responce';
import { WsService } from '../../../data/ws.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

class DropDownChoise<T> {
    item: T;
    type: 'item' | 'create-new';
}

@Component({
    selector: 'app-finish-vendor-search',
    templateUrl: './finish-vendor-search.component.html',
    styleUrls: ['./finish-vendor-search.component.scss']
})
@RxJSUnsubscribe
export class FinishVendorSearchComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    @Input()
    project: Project;

    @Input()
    vendorId: number;

    vendor: FinishingVendor;
    vendors: FinishingVendor[];

    currentChoise: DropDownChoise<FinishingVendor>;

    dropDownItems: DropDownChoise<FinishingVendor>[];

    searchQuery: string;

  wsSub: Subscription;
    constructor(
        protected projectService: ProjectService,
        protected finishingVendorService: FinishingVendorService,
        protected wsService: WsService
    ) { }

    ngOnInit() {
        this.finishingVendorService.getVendors().subscribe(vendors => {
            this.vendors = vendors
            this.vendor = this.vendors.find(vendor => vendor.id === this.vendorId)
        });


    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
            .pipe(
                filter(updateInfo => updateInfo.entity.id === this.project.id)

            )
            .subscribe(updateInfo => {
                if (updateInfo.action === 'UPDATE' && updateInfo.entity.finishingVendor) {
                    this.vendor = this.vendors.find(vendor => vendor.id === updateInfo.entity.finishingVendor.id)
                }
            })
    }

    statusChange(vendor: FinishingVendor) {
        this.vendor = vendor
        this.projectService
            .saveProject({
                id: this.project.id,
                finishingVendor: this.vendor
            })
            .subscribe(() => {
            })
    }

    filterCountrySingle(event) {
        this.searchQuery = event.query

        this.finishingVendorService
            .getVendors()
            .subscribe(vendors => {
                this.dropDownItems = vendors.map(vendor => {
                    return {
                        item: vendor,
                        type: 'item'
                    } as DropDownChoise<FinishingVendor>
                })
                this.dropDownItems.push({
                    item: null,
                    type: 'create-new'
                })

            })
    }

    updateVendor(choise: DropDownChoise<FinishingVendor>) {
        this.project.finishingVendor = choise.item;
        this.projectService
            .saveProject({
                id: this.project.id,
                finishingVendor: choise.item
            })
            .subscribe(project => {

            })
    }

    deleteVendor(event) {
        // this.projectService.detachCustomer(this.project.id).subscribe(project => {
        // 	this.project.customer.billingInfoContact.phone1 = '';
        // 	this.project.customer.billingInfoContact.email = ''
        // })
        console.log('DELETED')
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
